import type { DriverDocument, DriverDocuments } from '@/types';

/** Saudi mobile number format used by the target market. */
export const SA_PHONE_RE = /^05\d{8}$/;

export function cloneDocuments(docs?: DriverDocuments | null): DriverDocuments {
  const copy = (doc: DriverDocument | null | undefined): DriverDocument | null =>
    doc ? { ...doc } : null;
  return {
    nationalId: copy(docs?.nationalId),
    license: copy(docs?.license),
    vehicle: copy(docs?.vehicle),
  };
}